import { Directive } from '@angular/core';

@Directive({
  selector: '[appImgOrIcon]'
})
export class ImgOrIconDirective {

  constructor() { }

}
